import {
  GET_APPLIANCE_DATA,
  GET_APPLIANCE_DATA_SUCCESS,
  GET_APPLIANCE_DATA_FAILURE,
  REGISTER_APPLIANCE,
  REGISTER_APPLIANCE_SUCCESS,
  REGISTER_APPLIANCE_ERROR,
  EDIT_APPLIANCE,
  EDIT_APPLIANCE_SUCCESS,
  EDIT_APPLIANCE_ERROR,
  EDIT_CAMERA,
  EDIT_CAMERA_SUCCESS,
  EDIT_CAMERA_ERROR,
  UPDATE_CAMERA_TIME_SUCCESS,
} from "./actions";

const INIT_STATE = {
  appliances: {},
  cameras: {},
  camera_modes: {},
  camera_mode_list: [],
  error: "",
  loading: false,
  initial_load: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLIANCE_DATA:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_APPLIANCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        appliances: action.payload.appliances,
        cameras: action.payload.cameras,
        camera_modes: action.payload.modes,
        initial_load: true,
        error: "",
      };
    case GET_APPLIANCE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        initial_load: false,
        user: "",
        error: action.payload.message,
      };
    case REGISTER_APPLIANCE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case REGISTER_APPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        appliances: {
          ...state.appliances,
          [action.payload.appliance.appliance_id]: action.payload.appliance,
        },
        cameras: Object.assign({}, state.cameras, action.payload.cameras),
        error: "",
      };
    case REGISTER_APPLIANCE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_APPLIANCE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_APPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        appliances: {
          ...state.appliances,
          [action.payload.appliance_id]: action.payload,
        },
        error: "",
      };
    case EDIT_APPLIANCE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_CAMERA:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_CAMERA_SUCCESS:
      return {
        ...state,
        loading: false,
        cameras: {
          ...state.cameras,
          [action.payload.camera_id]: action.payload,
        },
        error: "",
      };
    case EDIT_CAMERA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case UPDATE_CAMERA_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
        cameras: {
          ...state.cameras,
          [action.payload.camera_id]: {
            ...state.cameras[action.payload.camera_id],
            ...action.payload,
          },
        },
        error: "",
      };

    default:
      return {
        ...state,
      };
  }
};
